import { shallowEqual, useSelector } from 'react-redux'
import { AsideMenuItem } from '../AsideMenuItem'
import { RootState } from '../../../../../setup'
import { UserModel } from '../../../../../app/modules/auth/models/UserModel'
import { hasPermission, hasRole } from '../../../../../app/utils/permissions'
import { Permission, UserRole } from '../../../../../app/constants/roles'

export function MenuPartner() {
  const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const canWaitList = hasPermission(user, Permission.MANAGE_WAITLIST_ADMIN)
  const canManageMember = hasPermission(user, Permission.MANAGE_MEMBER)
  const canMyExperience = hasPermission(user, Permission.MY_EXPERIENCE)
  const canMyExperiences = hasPermission(user, Permission.MY_EXPERIENCES)
  const canHostExperience = hasPermission(user, Permission.HOST_EXPERIENCE)
  const canExperiencesAdmin = hasPermission(user, Permission.EXPERIENCE_ADMIN)
  const canAdminTeam = hasPermission(user, Permission.ADMIN_TEAM)
  const canReferMember = hasPermission(user, Permission.REFER_MEMBER)
  const canManageAdmins = hasPermission(user, Permission.MANAGE_ADMIN)
  const canManagePartner = hasPermission(user, Permission.MANAGE_PARTNER)
  const canEditProfile = hasPermission(user, Permission.EDIT_PROFILE_IMAGE)
  const canEditBiography = hasPermission(user, Permission.EDIT_BIOGRAPHY)
  const canPartnerMyExperiences = hasPermission(user, Permission.PARTNER_MY_EXPERIENCE)
  const canMyTeam = hasPermission(user, Permission.TEAM)
  const canMyMembership = hasPermission(user, Permission.MY_MEMBERSHIP)
  const canPayments = hasPermission(user, Permission.PAYMENTS)
  const canFinancialOverview = hasPermission(user, Permission.FINANCIAL_OVERVIEW)
  const isPartner = hasRole(user,UserRole.PARTNER);
  // Mismo criterio que el redirect de PrivateRoutes y las tabs de /biography: el backend resuelve
  // `partnerType` en /users/current/ como 'Partner Expert' | 'Partner Agency'.
  const partnerType = user?.partnerType || (() => {
    try {
      const raw = localStorage.getItem('persist:auth') || localStorage.getItem('auth') || ''
      if (raw) {
        const parsed = JSON.parse(raw)
        const userObj = typeof parsed.user === 'string' ? JSON.parse(parsed.user) : parsed.user
        return userObj?.partnerType || ''
      }
    } catch (e) {
      return ''
    }
    return ''
  })()
  const isExpertPartner =
    isPartner && String(partnerType || '').toLowerCase().includes('expert')
  const isAgencyPartner =
    isPartner && String(partnerType || '').toLowerCase().includes('agency')

  return (<div className='nb-aside-content'>
    {/* REVIEW Section - Solo para waitlist users */}
    {(canWaitList) && (
        <div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
            <span className='nb-menu-section-title'>Review</span>
        </div>
        <div className='nb-menu-section-content'>
            {canWaitList && (<AsideMenuItem to='/waitinglist' title='users waitlist' showIcon={true} icon='/media/svg/nobilis/user_nb.svg' />)}
        </div>
        </div>
    )}

    {/* MY ACCOUNT Section - Para usuarios normales */}
    {(((canEditProfile && !isAgencyPartner) || canMyTeam || canReferMember || canEditBiography || canManageMember)) && (<div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
        <span className='nb-menu-section-title'>MY ACCOUNT</span>
        </div>
        <div className='nb-menu-section-content'>
        {canEditProfile && !isAgencyPartner && (<AsideMenuItem to='/biography' title='MY PROFILE' showIcon={true} icon='/media/svg/nobilis/user_nb-gray.svg' />)}
        {canMyTeam && (<AsideMenuItem to={`/user/${user?.id}/my-team`} title='MY TEAM' showIcon={true} icon='/media/svg/nobilis/my-team-icon.svg' />)}
        {canReferMember && (<AsideMenuItem to='/user/refer' title='Refer a Member' showIcon={true} icon='/media/svg/nobilis/team_menu_icon.svg' />)}
        {canManageMember && (<AsideMenuItem to='/manage-members' title='MANAGE MEMBERS' showIcon={true} icon='/media/svg/nobilis/user_nb.svg' />)}
        </div>
    </div>)}

    {/* Management */}
    {(canManagePartner || canManageAdmins) && (
        <div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
            <span className='nb-menu-section-title'>MANAGMENT</span>
        </div>
        <div className='nb-menu-section-content'>
            {canManageAdmins && (<AsideMenuItem to='/manage-admins' title='NOBILIS ADMIN' showIcon={true} icon='/media/svg/nobilis/user_nb.svg' />)}
            {canManagePartner && (<AsideMenuItem to='/manage-partners' title='PARTNERS' showIcon={true} icon='/media/svg/nobilis/partner-gray.svg' />)}
        </div>
        </div>
    )}

    {(canAdminTeam || canPartnerMyExperiences) && (
        <div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
            <span className='nb-menu-section-title'>Members Account</span>
        </div>
        <div className='nb-menu-section-content'>
            {canAdminTeam && (<AsideMenuItem to='/team/admin' title='Team' showIcon={true} icon='/media/svg/nobilis/user_nb-gray.svg' />)}
            {canMyExperiences && (<AsideMenuItem to='/partner/my-experiences' title='My Experiences' showIcon={true} icon='/media/svg/nobilis/exp_nb.svg' />)}
            {isExpertPartner && (<AsideMenuItem to='/messages' title='Messages' showIcon={true} icon='/media/svg/nobilis/ref_member-gray.svg' />)}
            {isExpertPartner && (<AsideMenuItem to='/my-expertise' title='My Expertise' showIcon={true} icon='/media/svg/nobilis/my-expertise.svg' />)}
            {isExpertPartner && (<AsideMenuItem to='/my-mastermind-circles' title='My Mastermind Circles' showIcon={true} icon='/media/svg/nobilis/my-mastermind-circles-gray.svg' />)}
        </div>
        </div>
    )}

    {/* Profile final user/partner */}
    {(canMyMembership || canPayments || canFinancialOverview) && (
        <div className='nb-menu-section'>
        <div className='nb-menu-section-header'>
            <span className='nb-menu-section-title'>Membership & Finance</span>
        </div>
        <div className='nb-menu-section-content'>
            {/* {canMyMembership && (<AsideMenuItem to='/financial/membership' title='My membership' showIcon={true} icon='/media/svg/nobilis/membership-gray.svg' />)} */}
            {canPayments && (<AsideMenuItem to='/user/payment/method' title='Payments' showIcon={true} icon='/media/svg/nobilis/payment-gray.svg' />)}
            {canFinancialOverview && (<AsideMenuItem to='/financial' title='financial overview' showIcon={true} icon='/media/svg/nobilis/financial-gray.svg' />)}
        </div>
        </div>
    )}
    </div>
  )
}
